import { Modal } from 'cpool-components/general/Modal';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuCircleX, LuTrash2 } from 'react-icons/lu';

type Props = {
    onClose: () => void;
    onConfirm: () => void;
    open: boolean;
};

export const DeleteDocumentModal: React.FC<Props> = ({ onClose, onConfirm, open }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('DOCUMENT_DEMANDER.SUMMARY.DELETE_MODAL.TITLE')}
            panelClassName="max-w-[512px]"
        >
            <div className="p-3 space-y-2 bg-white rounded-lg">
                <p className="mb-8 text-midnight">{t('DOCUMENT_DEMANDER.SUMMARY.DELETE_MODAL.BODY')}</p>
                <div className="flex justify-end gap-2">
                    <Button
                        iconLeft={<LuCircleX className="w-4 h-4" />}
                        variant={ButtonVariant.SECONDARY}
                        onClick={onClose}
                    >
                        {t('BUTTONS.CANCEL')}
                    </Button>
                    <Button iconLeft={<LuTrash2 className="w-4 h-4" />} onClick={onConfirm}>
                        {t('BUTTONS.DELETE')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
